import { render, staticRenderFns } from "./HirListaItem.vue?vue&type=template&id=0c30e847&"
import script from "./HirListaItem.vue?vue&type=script&lang=js&"
export * from "./HirListaItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports